export default [
  {
    original: require("../images/gallery/TK_archiv/1922.jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/1922.jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(2).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(3).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(3).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(5).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(5).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(6).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(6).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(7).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(7).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto_(8).jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto_(8).jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Foto.jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Foto.jpg")
  },
  {
    original: require("../images/gallery/TK_archiv/Schuetzenfest_1950.jpg"),
    thumbnail: require("../images/gallery/TK_archiv/thumb/Schuetzenfest_1950.jpg")
  }
];



// WEBPACK FOOTER //
// ./src/components/gallerylists/imageshistory.js